<template>
	<div class="search-form-wrap" :class="{'search-slide': mobileSearchForm}">
		<v-btn fab dark small class="close-btn" @click="toggleSearchForm">
			<v-icon dark>close</v-icon>
		</v-btn>
		<div class="d-flex align-center justify-center centered">
			<v-text-field
					ref="textFieldMovil"
					dark
					v-model="search"
					prepend-icon="search"
					:placeholder="placeholder"
					autocomplete="true"
					@keyup.enter="goSearch"
					color="white"
			>
			</v-text-field>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: ['value', 'placeholder'],
    data: () => ({
        search: null
    }),
  computed: {
    ...mapGetters(['mobileSearchForm'])
  },
	watch: {
        'mobileSearchForm' (val) {
            if(val) {
                this.search = this.value
                this.$refs.textFieldMovil.focus()
			}
		}
	},
  methods: {
        goSearch () {
            this.$emit('input', this.search)
			this.toggleSearchForm()
		},
    toggleSearchForm() {
		 this.$store.dispatch('toggleSearchForm');
	 }
  }
};
</script>

